"use client"

/**
 * Determines the media player mode based on available sources
 * @param {string} audioSrc - Audio source URL
 * @param {string} srtSrc - SRT subtitle source URL
 * @param {string} videoType - Video type (mp4, etc.)
 * @returns {string} Player mode: 'audio+srt', 'video+srt', 'srt-only', 'audio-only', 'video-only', or 'text-only'
 */
export const getMediaPlayerMode = (audioSrc, srtSrc, videoType) => {
  const hasAudio = !!audioSrc
  const hasVideo = !!videoType || (audioSrc && audioSrc.includes("mp4"))
  const hasSrt = !!srtSrc

  if (hasVideo && hasSrt) return "video+srt"
  if (hasAudio && hasSrt) return "audio+srt"
  if (hasSrt && !hasAudio && !hasVideo) return "srt-only"
  if (hasVideo) return "video-only"
  if (hasAudio) return "audio-only"
  return "text-only"
}

/**
 * Gets the controls configuration for a given player mode
 * @param {string} mode - Player mode
 * @returns {object} Controls configuration
 */
export const getControlsConfig = (mode) => {
  const configs = {
    "audio+srt": {
      showPlayPause: true,
      showRewind: true,
      showVolume: true,
      showSubtitles: true,
      showNavigation: true,
      defaultMuted: false,
    },
    "video+srt": {
      showPlayPause: true,
      showRewind: true,
      showVolume: true,
      showSubtitles: true,
      showNavigation: true,
      defaultMuted: false,
    },
    "srt-only": {
      showPlayPause: true,
      showRewind: true,
      showVolume: false,
      showSubtitles: false,
      showNavigation: true,
      defaultMuted: true,
    },
    "audio-only": {
      showPlayPause: true,
      showRewind: true,
      showVolume: true,
      showSubtitles: false,
      showNavigation: false,
      defaultMuted: false,
    },
    "video-only": {
      showPlayPause: true,
      showRewind: true,
      showVolume: true,
      showSubtitles: false,
      showNavigation: false,
      defaultMuted: false,
    },
    "text-only": {
      showPlayPause: false,
      showRewind: false,
      showVolume: false,
      showSubtitles: false,
      showNavigation: false,
      defaultMuted: true,
    },
  }

  return configs[mode] || configs["text-only"]
}
